import React from "react";
import { Tree } from "react-arborist";

import { Node } from "./Node";
import { normalizeSearchText } from "../../../utils/search";

type Grid = {
  name: string;
  cols?: Grid[];
  key: string;
  label: string;
  type: string;
};

interface IProps {
  grids: Grid[];
  search: string;
}

const Grids: React.FC<IProps> = ({ grids, search }) => {
  let data = grids.map((role: Grid, index: number) => {
    return {
      id: role.key + index,
      name: role.label,
      children:
        role.cols?.map((col, i) => {
          return {
            id: col.name + i + index,
            name: col.label,
            key: col.name,
          };
        }) || [],
      key: role.key,
    };
  });

  return (
    <Tree
      initialData={data}
      key="grids"
      openByDefault={false}
      rowHeight={40}
      searchMatch={(node, term) =>
        normalizeSearchText(node.data.name).includes(normalizeSearchText(term))
      }
      searchTerm={search}
    >
      {Node}
    </Tree>
  );
};

export default Grids;
